
import AC from '../util/ac'

export default {
  updateLogin(sate, acl) {
    sate.logged = true
    sate.ac = new AC(acl)
  },
  updateDefines(state, defines) {
    state.defines = defines
  },
    addProductInfo(state, info) {
      state.productInfo = info
    }
}
